import React from 'react';

export default function AuthProductBrand({ compact = false }) {
  return (
    <div className={`auth-product-brand ${compact ? 'is-compact' : ''}`.trim()}>
      <img src="/favicon.png" alt="Skill Share by Top Skilled Academy" />
      <span className="auth-product-brand-copy">
        <strong className="skillshare-wordmark">Skill Share</strong>
        <small>by Top Skilled Academy</small>
      </span>
    </div>
  );
}
